import ModalSelector from 'components/Modal/CommonModal/ModalSelector';
import { connect } from 'react-redux';
import { closeModal } from 'redux/modules/common-modal/actions';
import { getCommonModal } from 'redux/modules/common-modal/selectors';

export default connect(getCommonModal, { closeModal })(ModalSelector);
